(ns app.bundle-social-threads.platform
  "Threads profiles through bundle.social: a post with one video or
   image and the caption as its text.

   Only data and pure functions, see `app.bundle-social.platforms` for
   the keys. The profile of the OAuth is the publishing target, no page
   is picked afterwards."
  (:require [clojure.string :as str]))

(defn icon
  "Font Awesome's threads brand icon."
  [classes]
  [:svg {:xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 448 512"
         :fill "currentColor"
         :aria-hidden "true"
         :class classes}
   [:path {:d "M331.5 235.7c2.2 .9 4.2 1.9 6.3 2.8c29.2 14.1 50.6 35.2 61.8 61.4c15.7 36.5 17.2 95.8-30.3 143.2c-36.2 36.2-80.3 52.5-142.6 53h-.3c-70.2-.5-124.1-24.1-160.4-70.2c-32.3-41-48.9-98.1-49.5-169.6V256v-.2C17 184.3 33.6 127.2 65.9 86.2C102.2 40.1 156.2 16.5 226.4 16h.3c70.3 .5 124.9 24 162.3 69.9c18.4 22.7 32 50 40.6 81.7l-40.4 10.8c-7.1-25.8-17.8-47.8-32.2-65.4c-29.2-35.8-73-54.2-130.5-54.6c-57 .5-100.1 18.8-128.2 54.4C72.1 146.1 58.5 194.3 58 256c.5 61.7 14.1 109.9 40.3 143.3c28 35.6 71.2 53.9 128.2 54.4c51.4-.4 85.4-12.6 113.7-40.9c32.3-32.2 31.7-71.8 21.4-95.9c-6.1-14.2-17.1-26-31.9-34.9c-3.7 26.9-11.8 48.3-24.7 64.8c-17.1 21.8-41.4 33.6-72.7 35.3c-23.6 1.3-46.3-4.4-63.9-16c-20.8-13.8-33-34.8-34.3-59.3c-2.5-48.3 35.7-83 95.2-86.4c21.1-1.2 40.9-.3 59.2 2.8c-2.4-14.8-7.3-26.6-14.6-35.2c-10-11.7-25.6-17.7-46.2-17.8H227c-16.6 0-39 4.6-53.3 26.3l-34.4-23.6c19.2-29.1 50.3-45.1 87.8-45.1h.8c62.6 .4 99.9 39.5 103.7 107.7l-.2 .2zm-156 68.8c1.3 25.1 28.4 36.8 54.6 35.3c25.6-1.4 54.6-11.4 59.5-73.2c-13.2-2.9-27.8-4.4-43.4-4.4c-4.8 0-9.6 .1-14.4 .4c-42.9 2.4-57.2 23.2-56.2 41.8l-.1 .1z"}]])

(def max-topic-tag-length
  50)

(defn topic-tag-check
  "Threads rejects a topic tag with a period or an ampersand."
  [{:keys [topic-tag]}]
  (when (and topic-tag (re-find #"[.&]" topic-tag))
    "A Threads topic cannot contain a period (.) or an ampersand (&)."))

(defn topic-tag
  "The topic without the leading hash signs a user may type (`#summer`),
   nil when nothing is left."
  [topic]
  (some-> topic (str/replace #"^#+" "") str/trim not-empty))

(defn post-data
  "The `data.THREADS` entry of a bundle.social post, with who can reply
   (`replyControl`) and the optional topic (`topicTag`) chosen on the
   scheduling page."
  [{:keys [text upload-id options]}]
  (let [topic (topic-tag (:topic-tag options))]
    (cond-> {:uploadIds [upload-id]
             ;; The default for posts scheduled before the option.
             :replyControl (:reply-control options "everyone")}
      (seq text)
      (assoc :text text)

      topic
      (assoc :topicTag topic))))

(def platform
  {:social-platform/id "THREADS"
   :social-platform/key :threads
   :social-platform/name "Threads"
   :social-platform/account-noun "Threads profile"
   :social-platform/icon icon
   :social-platform/text-class ["text-gray-900"]
   :social-platform/pill-class ["bg-gray-50" "border-gray-200" "text-gray-800"]
   :social-platform/launched? true
   :social-platform/connect-card
   {:eyebrow "Video & image posts"
    :description "Connect a Threads profile for scheduled video and image posts."
    :button-text "Connect Threads"
    :style {:card-class ["border-gray-300" "bg-white" "hover:border-gray-400"]
            :eyebrow-class ["bg-gray-100" "text-gray-700" "ring-gray-200"]
            :icon-class ["bg-black" "text-white" "ring-gray-300"]
            :title-class ["text-gray-900"]
            :description-class ["text-gray-600"]
            :button-class ["bg-black" "text-white" "hover:bg-gray-800"]
            :rail-class ["bg-black"]}}
   :social-platform/post-data post-data
   ;; Threads takes videos up to 5 minutes and captions up to 500
   ;; characters (https://info.bundle.social/api-reference/platforms/threads).
   :social-platform/post-types
   [{:post-type/id "POST"
     :post-type/kind :threads-post
     :post-type/label "Threads post"
     :post-type/group-label "Threads"
     :post-type/media #{:video :image}
     :post-type/max-duration-seconds 300
     :post-type/caption? true
     :post-type/max-text-length 500
     :post-type/options-check topic-tag-check
     :post-type/options
     [{:option/key :reply-control
       :option/label "Who can reply"
       :option/choices [{:choice/value "everyone"
                         :choice/label "Everyone"}
                        {:choice/value "followers_only"
                         :choice/label "Followers"}
                        {:choice/value "accounts_you_follow"
                         :choice/label "Profiles you follow"}
                        {:choice/value "mentioned_only"
                         :choice/label "Mentioned profiles only"}]}
      {:option/key :topic-tag
       :option/type :text
       :option/label "Topic"
       :option/max-length max-topic-tag-length
       :option/hint "Optional. One topic shown in the post's header, without periods or ampersands."}]}]})
